import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
import { DomainsPermissions } from '@wix/domains-serverless-interface';
import { DomainsApiClient } from '@wix/domains-serverless-interface/react-kit';
import { createApiClient, createQueriesConfig, QueryConfigTypes } from '@wix/premium-fed-sdk/@apis-infra-react';
const apiConfig = createQueriesConfig({
  purchasePermission: {
    queryFn: async _ref => {
      let httpClient = _ref.httpClient;
      const _DomainsApiClient$que = DomainsApiClient.queries({
          httpClient
        }),
        domainsAccountPermissions = _DomainsApiClient$que.domainsAccountPermissions;
      const account = await domainsAccountPermissions({});
      if (!(account != null && account.domainPermissions)) {
        return {
          hasPermission: false
        };
      }
      const isSiteLevel = !!account.msid;
      const userPermissions = new Set(account.domainPermissions ?? []);
      return {
        hasPermission: userPermissions.has(isSiteLevel ? DomainsPermissions.SiteLevelPurchaseDomain : DomainsPermissions.AccountLevelPurchaseDomain)
      };
    },
    queryConfigType: QueryConfigTypes.MODERATE_DATA
  },
  tldsEligibleForVoucher: {
    queryFn: async _ref2 => {
      var _site$value, _coupons$value;
      let httpClient = _ref2.httpClient,
        msid = _ref2.request.msid;
      const _DomainsApiClient$que2 = DomainsApiClient.queries({
          httpClient
        }),
        getSite = _DomainsApiClient$que2.getSite,
        domainTlds = _DomainsApiClient$que2.domainTlds,
        listEligibleCoupons = _DomainsApiClient$que2.listEligibleCoupons;
      const _await$Promise$allSet = await Promise.allSettled([msid ? getSite({
          msid
        }) : Promise.resolve(undefined), domainTlds({}), listEligibleCoupons({})]),
        site = _await$Promise$allSet[0],
        tlds = _await$Promise$allSet[1],
        coupons = _await$Promise$allSet[2];
      return {
        isPremiumSite: site.status === 'fulfilled' && Boolean((_site$value = site.value) == null ? void 0 : _site$value.allowedDomain),
        hasValidVouchers: coupons.status === 'fulfilled' && Boolean((_coupons$value = coupons.value) == null || (_coupons$value = _coupons$value.coupons) == null ? void 0 : _coupons$value.length),
        voucherSupportedTlds: tlds.status === 'fulfilled' ? tlds.value.tlds.filter(_ref3 => {
          let couponsApplicable = _ref3.couponsApplicable;
          return couponsApplicable;
        }).map(_ref4 => {
          let tld = _ref4.tld;
          return tld;
        }) : []
      };
    },
    queryConfigType: QueryConfigTypes.MODERATE_DATA
  }
});
const _createApiClient = createApiClient(apiConfig),
  Provider = _createApiClient.Provider,
  apiClient = _objectWithoutPropertiesLoose(_createApiClient, ["Provider"]);
export const GateApiClient = apiClient;
//# sourceMappingURL=domainSearchGate.apiClient.js.map